import { render, staticRenderFns } from "./InventoryStateSwitchConfig.vue?vue&type=template&id=7a8fc60a&scoped=true"
import script from "./InventoryStateSwitchConfig.vue?vue&type=script&lang=js"
export * from "./InventoryStateSwitchConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8fc60a",
  null
  
)

export default component.exports